<template>
  <MapPopup
      icon="icon-pin"
      :title="poi?.name"
      @close="emit('close')"
  >
    <div class="map-popup__row">
      <span class="label">
        {{ $t('validation.attributes.description') }}
      </span>
      <span class="value">
        {{ poi?.description }}
      </span>
    </div>
  </MapPopup>
</template>
<script setup>
import MapPopup from "@/js/Components/MapPopup/Popup.vue";
import {computed, onBeforeUnmount} from "vue";
import {useStore} from "vuex";
import {useEmitter} from "@/js/Plugins/Emitter.js";

const emitter = useEmitter();
const store = useStore();
const emit = defineEmits(['close']);
const props = defineProps({
  id: [Number, String],
});
const poi = computed(() => store.getters['poi/find'](props.id));

onBeforeUnmount(() => {
  emitter.off('poi:deleted', onDelete);
});
emitter.on('poi:deleted', onDelete);

function onDelete() {
  emit('close');
}
</script>